(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabbed-vitrines"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabbedVitrines extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.mobileSelect = this.querySelector('[data-mobile-select]');
      this.mobileTrigger = this.mobileSelect?.querySelector('.collection-tabbed-vitrines__mobile-trigger');
      this.mobileLabel = this.mobileSelect?.querySelector('[data-mobile-label]');
      this.mobileOptions = Array.from(
        this.mobileSelect?.querySelectorAll('.collection-tabbed-vitrines__mobile-option') || []
      );

      if (!this.tabs.length || !this.panels.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab, true));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
      });

      this.syncMobileLabel();

      this.mobileTrigger?.addEventListener('click', () => this.toggleMobileSelect());
      this.mobileOptions.forEach((option) => {
        option.addEventListener('click', () => {
          const tab = this.querySelector(`#${option.dataset.tabId}`);
          if (tab) this.activateTab(tab, true);
          this.closeMobileSelect();
        });
      });

      document.addEventListener('click', (event) => {
        if (this.mobileSelect?.classList.contains('is-open') && !this.mobileSelect.contains(event.target)) {
          this.closeMobileSelect();
        }
      });
    }

    syncMobileLabel() {
      if (!this.mobileLabel) return;

      const selectedOption = this.mobileOptions.find(
        (option) => option.getAttribute('aria-selected') === 'true'
      );
      const activeTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      const label = (selectedOption?.textContent || activeTab?.textContent || '').trim();

      if (label) this.mobileLabel.textContent = label;
    }

    activateTab(selectedTab, updateMobile = false) {
      const targetId = selectedTab.getAttribute('aria-controls');
      const tabLabel = selectedTab.textContent.trim();

      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === targetId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;

        if (isActive) {
          requestAnimationFrame(() => {
            panel.querySelectorAll('slider-component').forEach((slider) => {
              if (typeof slider.resetPages === 'function') slider.resetPages();
            });
          });
        }
      });

      if (updateMobile) {
        this.mobileOptions.forEach((option) => {
          const isSelected = option.dataset.tabId === selectedTab.id;
          option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });
        if (this.mobileLabel) this.mobileLabel.textContent = tabLabel;
      }
    }

    toggleMobileSelect() {
      const isOpen = this.mobileSelect.classList.toggle('is-open');
      this.mobileTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    closeMobileSelect() {
      this.mobileSelect?.classList.remove('is-open');
      this.mobileTrigger?.setAttribute('aria-expanded', 'false');
    }

    handleKeydown(event, currentTab) {
      const currentIndex = this.tabs.indexOf(currentTab);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.tabs[nextIndex].focus();
      this.activateTab(this.tabs[nextIndex], true);
    }
  }

  if (!customElements.get('collection-tabbed-vitrines')) {
    customElements.define('collection-tabbed-vitrines', CollectionTabbedVitrines);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["granola-version-tabs"] && !Shopify.designMode) return;
  try {
    
  class GranolaVersionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tabs.length || !this.panels.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
      });
    }

    activateTab(tab) {
      const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
      if (!panel) return;

      this.tabs.forEach((item) => {
        const isActive = item === tab;
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((item) => {
        const isActive = item === panel;
        item.classList.toggle('is-active', isActive);
        item.hidden = !isActive;
      });
    }

    handleKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      let nextIndex = null;

      if (event.key === 'ArrowRight') {
        nextIndex = (index + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }

      if (nextIndex === null) return;

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex]);
      this.tabs[nextIndex].focus();
    }
  }

  if (!customElements.get('granola-version-tabs')) {
    customElements.define('granola-version-tabs', GranolaVersionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = throttle(this.onScroll.bind(this), 100);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  class TabbedCollections extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tabs.length || !this.panels.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
      });
    }

    activateTab(selectedTab) {
      const targetId = selectedTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === targetId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    handleKeydown(event, currentTab) {
      const currentIndex = this.tabs.indexOf(currentTab);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.tabs[nextIndex].focus();
      this.activateTab(this.tabs[nextIndex]);
    }
  }

  if (!customElements.get('tabbed-collections')) {
    customElements.define('tabbed-collections', TabbedCollections);
  }

  } catch(e) { console.error(e); }
})();
})();
